module.exports = __webpack_public_path__ + "static/carte_aws-cb71ccb387c3ed4eeeca3089db730948.svg";